var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"input-styles",attrs:{"type":"tel","disabled":_vm.disabled,"value":_vm.phone,"rules":_vm.rules,"label":"Phone Number","maxlength":"14","height":"48","placeholder":" ","outlined":"","persistent-placeholder":"","required":"","autofocus":_vm.autofocus},on:{"input":(val) => _vm.updatePhone(val),"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }